import { useSaveStatus } from '@/hooks/useSaveStatus';
import { useRelativeTime } from '@/hooks/useRelativeTime';
import clsx from 'clsx';

export function SaveIndicator() {
  const status = useSaveStatus();
  const lastSaved = status.kind === 'idle' ? status.lastSavedAt : null;
  const relativeTime = useRelativeTime(lastSaved);

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 text-[12px] tabular-nums"
    >
      <Dot status={status.kind} />
      <span className="text-text-2 font-medium">{label(status, relativeTime)}</span>
      {status.kind === 'idle' && lastSaved !== null && relativeTime && (
        <span className="text-text-4">· {relativeTime}</span>
      )}
    </div>
  );
}

function Dot({ status }: { status: 'idle' | 'saving' | 'queued' | 'error' }) {
  return (
    <span
      aria-hidden="true"
      className={clsx(
        'h-1.5 w-1.5 rounded-full',
        status === 'idle' && 'bg-ok',
        status === 'saving' && 'bg-accent animate-pulse',
        status === 'queued' && 'bg-warn',
        status === 'error' && 'bg-err',
      )}
    />
  );
}

function label(
  status: ReturnType<typeof useSaveStatus>,
  _relativeTime: string,
): string {
  switch (status.kind) {
    case 'idle':
      return status.lastSavedAt ? 'Saved' : 'Ready';
    case 'saving':
      return 'Saving…';
    case 'queued':
      return `${status.count} queued`;
    case 'error':
      return 'Sync failed';
  }
}
